module.exports = __webpack_public_path__ + "static/media/organization-setting.9941d4f1.png";